import { createContext, useState } from "react";

const LocationsContext = createContext();

const LocationsContextProvider = ({ children }) => {
    const [draftStatusChanged , setDraftStatusChanged] = useState(false)
    return(
        <LocationsContext.Provider 
            value={{
                draftStatusChanged,
                setDraftStatusChanged
            }}
        >
            {children}
        </LocationsContext.Provider>
    )
}

export {LocationsContext , LocationsContextProvider}